import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mes'
})
export class MesPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value=='01')return 'Janeiro';
    if(value=='02')return 'Fevereiro';
    if(value=='03')return 'Março';
    if(value=='04')return 'Abril';
    if(value=='05')return 'Maio';
    if(value=='06')return 'Junho';
    if(value=='07')return 'Julho';
    if(value=='08')return 'Agosto';
    if(value=='09')return 'Setembro';
    if(value=='10')return 'Outubro';
    if(value=='11')return 'Novembro';
    if(value=='12')return 'Dezembro';
    return value;
  }

}
